import { __assign, __rest } from "tslib";
/* eslint-disable react/button-has-type */
import React, { createElement, useCallback } from 'react';
import classnames from 'classnames';
import { useFormInfo } from '../Form/defs';
import { concat } from '../utils';
import { usePrefix } from '../ConfigProvider';
import { LoadingThinIcon } from '../icons';
import { useAnimationCls } from '../utils/hooks';
export default function Button(props) {
    var children = props.children, _a = props.type, type = _a === void 0 ? 'default' : _a, _b = props.danger, danger = _b === void 0 ? false : _b, size = props.size, icon = props.icon, endIcon = props.endIcon, _c = props.htmlType, htmlType = _c === void 0 ? 'button' : _c, loading = props.loading, onClick = props.onClick, disabled = props.disabled, className = props.className, as = props.as, rootHtmlProps = props.rootHtmlProps, style = props.style, rest = __rest(props, ["children", "type", "danger", "size", "icon", "endIcon", "htmlType", "loading", "onClick", "disabled", "className", "as", "rootHtmlProps", "style"]);
    var formInfo = useFormInfo();
    var finalDisabled = disabled || loading; // loading 的时候按钮也应该被禁用
    var prefix = usePrefix('btn');
    var typePrefix = concat(prefix, type);
    var dangerPrefix = concat(prefix, 'danger');
    var sizePrefix = concat(typePrefix, size !== null && size !== void 0 ? size : formInfo.size);
    var loadingPrefix = concat(typePrefix, 'loading');
    var contentPrefix = concat(prefix, 'content');
    var iconPrefix = concat(contentPrefix, 'icon');
    var endIconPrefix = concat(contentPrefix, 'endicon');
    var classname = classnames(prefix, typePrefix, sizePrefix, danger && dangerPrefix, loading && loadingPrefix, finalDisabled && concat(prefix, 'disabled'), className, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    var spinCls = useAnimationCls().spinCls;
    var startIcon = loading
        ? React.createElement("span", { className: iconPrefix },
            React.createElement(LoadingThinIcon, { className: spinCls }))
        : icon && React.createElement("span", { className: iconPrefix }, icon);
    var handleClick = useCallback(function (e) {
        var _a;
        if (finalDisabled)
            return;
        (_a = rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.onClick) === null || _a === void 0 ? void 0 : _a.call(rootHtmlProps, e);
        if (e.defaultPrevented)
            return;
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [rootHtmlProps, onClick, finalDisabled]);
    var rootProps = __assign(__assign(__assign({}, rootHtmlProps), { type: htmlType, className: classname, style: __assign(__assign({}, style), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.style), onClick: ((rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.onClick) || onClick) && handleClick, disabled: finalDisabled }), rest);
    return createElement(as !== null && as !== void 0 ? as : 'button', rootProps, (React.createElement("span", { className: contentPrefix },
        startIcon,
        children && React.createElement("span", null, children),
        endIcon && React.createElement("span", { className: endIconPrefix }, endIcon))));
}
//# sourceMappingURL=index.js.map